<template>
    <div
            class="">
        <h4 class="text-center">Settings</h4>

        <!-- Automatic Sending Interval -->
        <div class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
            <span   v-if="isSavable">Automatic Sending Interval</span>
            <span   v-else>Reporting Interval</span>
            <select2 :options="intervals"
                     v-model:value="$data._interval"
                     :close-on-select="true"
            ></select2>
        </div>

        <!-- Day of week to send -->
        <div    v-if="permissions.can('manage_detailed_alarm_report')
                              && interval === 'weekly'
                              && isSavable"
                class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
            <span>Day of Week to Send Report</span>
            <select2 id="day_of_week[]"
                     v-model="$data._settings['weekday']"
                     :close-on-select="true"
                     :options="weekdayOptions"
                     @input="updateSettings($event, 'weekday')">

            </select2>
        </div>
    </div>
</template>

<script>
import axios from "axios"

import {SonicuCoreMixin} from "../../mixins/SonicuCoreMixin";

import Select2 from "../elements/select2";

const INTERVALS = {
    daily: 'Daily',
    weekly: 'Weekly',
    'semi-monthly': 'Semi-Monthly',
    monthly: 'Monthly',
}

const WEEKDAY_OPTIONS = {
    0: "Sunday",
    1: "Monday",
    2: "Tuesday",
    3: "Wednesday",
    4: "Thursday",
    5: "Friday",
    6: "Saturday",
}

export default {
    name: "DetailedAlarmReportSettings",
    mixins: [SonicuCoreMixin],
    components: {Select2},
    props: {
        receiveWeekday: {
            type: [Number, String],
            default: 1,
        },
        semiMonthHalf: {
            type: String,
            default: 'first',
        },
        // TODO. include this in JS instead
        weekdayOptions: {
            type: Object,
            default: WEEKDAY_OPTIONS,
        },
        intervals: {
            type: Object,
            default: INTERVALS,
        },
        interval: {
            type: String,
            default: 'monthly',
        },
        isSavable: {
            type: Boolean,
            default: false,
        },
        settings: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            _receiveWeekday: this.receiveWeekday,
            _interval: this.interval,
            _settings: this.settings,
            isSaving: false,
        }
    },
    created() {
        if (! _.has(this.$data._settings, 'weekly')) {
            this.$data._settings['weekday'] = 1
        }
    },
    mounted() {

    },
    methods: {
        updateSettings(event, triggeringComponent = 'Unknown') {
            // Update the settings values based on the new local
            this.$emit('update:settings', this.$data._settings)
            this.$forceUpdate()
        },
        saveSettings() {
            this.$emit(`saveSettings`)
        },
    },
    computed: {},
    watch: {
        _interval(val, old) {
            if (val !== old) {
                this.$emit('update:interval', this.$data._interval)
            }
        },
        _receiveWeekday (val, old) {
            if (val !== old) {
                this.$emit('update:receiveWeekday', this.$data._receiveWeekday)
            }
        },
        settings (val, old) {
            if (val !== old) {
                this.$data._settings = val
            }
        }
    },
}
</script>

<style scoped>

</style>